// Must precede every other import: it disables Zod's `new Function`
// codegen probe, which our CSP blocks, and Zod reads that flag when the
// first object schema is constructed at module scope.
import './zod-jitless';

import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.scss';

import App from './App';
import { setupSentry } from './shared/utils/sentry';

setupSentry();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
